
import { defineComponent, computed, ref, SetupContext } from 'vue';

export default defineComponent({
  name: 'TDivider',
  components: {},
  props: {
    hasBorder: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'horizontal',
      validator: (value: string) => ['horizontal', 'vertical'].includes(value),
    },
    size: {
      type: String,
      default: 'medium',
      validator: (value: string) => ['medium', 'small'].includes(value),
    },
    theme: {
      type: String,
      default: 'default',
      validator: (value: string) => ['default', 'primary', 'highlight'].includes(value),
    },
    orientation: {
      type: String,
      default: 'center',
      validator: (value: string) => ['left', 'right', 'center'].includes(value),
    },
  },
  emits: ['click'],
  setup(props, context: SetupContext) {
    /** 组件的className前辍 */
    const prefixCls = ref('t-divider');
    /** 模板依赖的className */
    const getClasses = computed(() => {
      return {
        wrap: [
          prefixCls.value,
          props.hasBorder && `${prefixCls.value}-border`,
          `${prefixCls.value}-type__${props.type}`,
          !props.title && props.type === 'horizontal' && `${prefixCls.value}-size__${props.size}`,
        ],
        body: [`${prefixCls.value}-bd`],
        bg: [`${prefixCls.value}-bg`, `${prefixCls.value}-theme__${props.theme}`],
        title: [`${prefixCls.value}-title`],
        before: [
          `${prefixCls.value}-line`,
          `${prefixCls.value}-theme__${props.theme}`,
          `${prefixCls.value}-before__${props.orientation}`,
        ],
        after: [
          `${prefixCls.value}-line`,
          `${prefixCls.value}-theme__${props.theme}`,
          `${prefixCls.value}-after__${props.orientation}`,
        ],
      };
    });
    /** 对外响应的事件 */
    const listener = (event: any) => context.emit('click', event);

    return { prefixCls, getClasses, listener };
  },
});
